// src/components/MapComponent.jsx
import React from 'react';
import { MapContainer, TileLayer, Marker, Tooltip, ZoomControl } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const MapComponent = () => {
  const position = [-34.61225, -58.41931]; // Coordenadas del negocio (Colombres 87, C1416 CABA)
  const placeName = 'Persianas de aluminio inyectado y de PVC plásticas Ferracort';
  const address   = 'Colombres 87, C1416 Cdad. Autónoma de Buenos Aires';

  // URL a la FICHA en Google Maps (usa nombre + dirección)
  const googlePlaceUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    `${placeName}, ${address}`
  )}`;

  // URL "Cómo llegar" (destino = dirección del negocio)
  const googleDirectionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;

  const openPlace = () => window.open(googlePlaceUrl, '_blank', 'noopener,noreferrer');
  const openDirections = () => window.open(googleDirectionsUrl, '_blank', 'noopener,noreferrer');

  // Marcador con pin + pulso
  const customIcon = L.divIcon({
    className: 'custom-marker',
    html: `
      <div class="pin-wrap">
        <div class="pin"></div>
        <div class="pulse"></div>
      </div>
    `,
    iconSize: [30, 42],
    iconAnchor: [15, 42],
  });

  return (
    <div className="map-card">
      <style>{`
        .map-card {
          position: relative;
          width: 100%;
          height: 360px;
          border-radius: 16px;
          overflow: hidden;
          background: #ffffff; /* FONDO BLANCO */
          border: 1px solid rgba(0,0,0,0.08);
          box-shadow:
            0 1px 0 rgba(255,255,255,0.9) inset,
            0 12px 24px rgba(0,0,0,0.08);
        }
        /* Botones flotantes */
        .btns {
          position: absolute;
          z-index: 1000;
          right: 12px;
          bottom: 12px;
          display: grid;
          gap: 8px;
        }
        .map-cta, .map-dir {
          padding: 10px 14px;
          border-radius: 12px;
          border: none;
          font-weight: 800;
          letter-spacing: .04em;
          cursor: pointer;
          transition: transform .15s ease, box-shadow .2s ease, filter .2s ease;
          box-shadow: 0 8px 18px rgba(0,0,0,.16);
        }
        .map-cta {
          background: linear-gradient(180deg, #F3D462 0%, #DAA520 100%);
          color: #111;
        }
        .map-dir {
          background: #ffffff;
          color: #111;
          border: 1px solid rgba(0,0,0,.12);
        }
        .map-cta:hover, .map-dir:hover { transform: translateY(-2px); box-shadow: 0 12px 28px rgba(0,0,0,.2); }

        /* Marcador 3D con pulso */
        .custom-marker .pin-wrap { position: relative; width: 30px; height: 42px; }
        .custom-marker .pin {
          width: 18px; height: 18px; background: #DAA520; border: 2px solid #000;
          border-radius: 50%; position: absolute; left: 50%; top: 0; transform: translateX(-50%);
          box-shadow: 0 6px 16px rgba(218,165,32,.5);
        }
        .custom-marker .pin::after {
          content: ""; position: absolute; left: 50%; bottom: -18px; transform: translateX(-50%);
          width: 2px; height: 20px; background: #DAA520; border-radius: 2px; box-shadow: 0 0 0 1px rgba(0,0,0,.5) inset;
        }
        .custom-marker .pulse {
          position: absolute; left: 50%; top: 9px; transform: translate(-50%, -50%);
          width: 6px; height: 6px; border-radius: 50%; background: rgba(218,165,32,.65);
          animation: pulse 1.6s ease-out infinite; filter: blur(0.3px);
        }
        @keyframes pulse {
          0% { box-shadow: 0 0 0 0 rgba(218,165,32,.55); opacity: 1; }
          100% { box-shadow: 0 0 0 16px rgba(218,165,32,0); opacity: 0; }
        }

        /* Tooltip */
        .leaflet-tooltip.custom-label {
          background: rgba(0,0,0,.78);
          color: #F5DEB3;
          border: 1px solid rgba(218,165,32,.38);
          border-radius: 10px;
          padding: 6px 10px;
          font-weight: 800;
          letter-spacing: .02em;
          box-shadow: 0 8px 18px rgba(0,0,0,.25);
        }

        /* Controles claros sobre fondo blanco */
        .leaflet-control-zoom {
          border: 1px solid rgba(0,0,0,.12);
          box-shadow: 0 6px 14px rgba(0,0,0,.12);
        }
        .leaflet-control-zoom a {
          background: #fff; color: #111;
        }
        .leaflet-control-attribution {
          background: rgba(255,255,255,.9);
          color: rgba(0,0,0,.7);
          border-radius: 6px 0 0 0;
        }
      `}</style>

      <MapContainer
        center={position}
        zoom={15}
        scrollWheelZoom={false}
        zoomControl={false}
        preferCanvas
        style={{ height: '100%', width: '100%' }}
      >
        {/* Tile CLARO (fondo blanco) */}
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        />

        <Marker
          position={position}
          icon={customIcon}
          eventHandlers={{ click: openPlace }} // abre la ficha al tocar el marcador
        >
          <Tooltip
            direction="top"
            offset={[0, -18]}
            opacity={1}
            permanent
            className="custom-label"
          >
            Ferracort • Tocar para abrir
          </Tooltip>
        </Marker>

        <ZoomControl position="bottomright" />
      </MapContainer>

      {/* Botones flotantes */}
      <div className="btns">
        <button className="map-cta" onClick={openPlace}>Abrir en Google Maps</button>
        <button className="map-dir" onClick={openDirections}>Cómo llegar</button>
      </div>
    </div>
  );
};

export default MapComponent;
